import * as React from 'react';

import { WatermarkActionContext, WatermarkValueContext } from './context';
import { useWatermarkAction, useWatermarkValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const WatermarkFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <WatermarkValueContext.Provider value={state}>
      <WatermarkActionContext.Provider value={dispatch}>
        {children}
      </WatermarkActionContext.Provider>
    </WatermarkValueContext.Provider>
  );
};

export { useWatermarkAction, useWatermarkValue, WatermarkFormContext };
